module.exports = __webpack_public_path__ + "img/consult_info4.b76e654a.png";